/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { Sperrigkeit } from '../models';
/**
 * SperrigkeitService - axios parameter creator
 * @export
 */
export const SperrigkeitServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Sperrigkeiten
         * @summary Sperrigkeiten
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSperrigkeiten: async (mandant?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sperrigkeiten`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mandant !== undefined) {
                localVarQueryParameter['mandant'] = mandant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SperrigkeitService - functional programming interface
 * @export
 */
export const SperrigkeitServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SperrigkeitServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Sperrigkeiten
         * @summary Sperrigkeiten
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSperrigkeiten(mandant?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sperrigkeit>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSperrigkeiten(mandant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SperrigkeitService - factory interface
 * @export
 */
export const SperrigkeitServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SperrigkeitServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Sperrigkeiten
         * @summary Sperrigkeiten
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSperrigkeiten(mandant?: number, options?: any): AxiosPromise<Array<Sperrigkeit>> {
            return localVarFp.getSperrigkeiten(mandant, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SperrigkeitService - interface
 * @export
 * @interface SperrigkeitService
 */
export interface SperrigkeitServiceInterface {
    /**
     * Liefert eine Liste von Sperrigkeiten
     * @summary Sperrigkeiten
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SperrigkeitServiceInterface
     */
    getSperrigkeiten(mandant?: number, options?: any): AxiosPromise<Array<Sperrigkeit>>;

}

/**
 * SperrigkeitService - object-oriented interface
 * @export
 * @class SperrigkeitService
 * @extends {BaseAPI}
 */
export class SperrigkeitService extends BaseAPI implements SperrigkeitServiceInterface {
    /**
     * Liefert eine Liste von Sperrigkeiten
     * @summary Sperrigkeiten
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SperrigkeitService
     */
    public getSperrigkeiten(mandant?: number, options?: any) {
        return SperrigkeitServiceFp(this.configuration).getSperrigkeiten(mandant, options).then((request) => request(this.axios, this.basePath));
    }
}
